<div [matTooltip]="tooltip" [matTooltipDisabled]="!hasTooltip">
  <button matButton (click)="action.emit()" [disabled]="disabled">
    <ng-content></ng-content>

    <mat-icon iconPositionEnd>chevron_right</mat-icon>
  </button>
</div>
